import { defineMessages } from 'react-intl';

export default defineMessages({
    company: {
        id: 'e1p.gateway.contacts.components.ContactDetailsCompany.Company',
        defaultMessage: 'Company'
    },
    officePhone: {
        id: 'e1p.gateway.contacts.components.ContactDetailsCompany.OfficePhone',
        defaultMessage: 'Office Phone'
    },
    fax: {
        id: 'e1p.gateway.contacts.components.ContactDetailsCompany.Fax',
        defaultMessage: 'Fax'
    },
    companyPrimaryEmail: {
        id: 'e1p.gateway.contacts.components.ContactDetailsCompany.PrimaryEmail',
        defaultMessage: 'Primary Email'
    },
    companyAddress: {
        id: 'e1p.gateway.contacts.components.ContactDetailsCompany.Address',
        defaultMessage: 'Address'
    },
    person: {
        id: 'e1p.gateway.contacts.components.ContactDetailsPerson.Person',
        defaultMessage: 'Person'
    },
    dateOfBirth: {
        id: 'e1p.gateway.contacts.components.ContactDetailsPerson.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    maritaStatus: {
        id: 'e1p.gateway.contacts.components.ContactDetailsPerson.Marital Status',
        defaultMessage: 'Marital Status'
    },
    homePhone: {
        id: 'e1p.gateway.contacts.components.ContactDetailsPerson.home',
        defaultMessage: 'Home Phone'
    },
    homePhonePrimary: {
        id: 'e1p.gateway.contacts.components.ContactDetailsPerson.home primary',
        defaultMessage: 'Home Phone (primary)'
    },
    workPhone: {
        id: 'e1p.gateway.contacts.components.ContactDetailsPerson.work',
        defaultMessage: 'Work Phone'
    },
    workPhonePrimary: {
        id: 'e1p.gateway.contacts.components.ContactDetailsPerson.work primary',
        defaultMessage: 'Work Phone (primary)'
    },
    mobile: {
        id: 'e1p.gateway.contacts.components.ContactDetailsPerson.mobile',
        defaultMessage: 'Mobile'
    },
    mobilePrimary: {
        id: 'e1p.gateway.contacts.components.ContactDetailsPerson.mobile primary',
        defaultMessage: 'Mobile (primary)'
    },
    personPrimaryEmail: {
        id: 'e1p.gateway.contacts.components.ContactDetailsPerson.Primary Email',
        defaultMessage: 'Primary Email'
    },
    personAddress: {
        id: 'e1p.gateway.contacts.components.ContactDetailsPerson.Address',
        defaultMessage: 'Address'
    },
    roles: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Title',
        defaultMessage: 'Roles'
    },
    associatedAccounts: {
        id: 'e1p.gateway.contacts.common.components.AccountContactDetail.Associated Accounts',
        defaultMessage: 'Associated Accounts'
    }
});
